import React from "react";
import { SelectField, CheckGroup } from "../../components/ui/UIComponents";

// ─────────────────────────────────────────────────────────────────────────────
// STEP 5 — Interests & Preferences
// ─────────────────────────────────────────────────────────────────────────────

const FIELDS = [
  "IT / Software Development",
  "Data Science & Analytics",
  "Artificial Intelligence / ML",
  "Cybersecurity",
  "Cloud & DevOps",
  "Core Engineering (Mech/Civil/EEE)",
  "Government Job / Civil Services",
  "Banking & Finance",
  "Business / Entrepreneurship",
  "Startup Ecosystem",
  "Teaching / Academia",
  "Healthcare / Biotech",
  "Creative / UI-UX Design",
  "Content & Digital Marketing",
  "Law / Management",
];

const WORK_TYPES = [
  "Work from Home / Remote",
  "Office Job (Regular 9–6)",
  "Hybrid (WFH + Office)",
  "Field Job / On-site",
  "Freelancing",
  "Abroad Opportunity",
];

const GOALS = [
  "Get placed within 6 months",
  "Higher studies (M.Tech / MBA / MS abroad)",
  "Crack government exam (UPSC / SSC / Bank)",
  "Start my own business / startup",
  "Freelancing & self-employment",
  "Work abroad (US / UK / Canada / Gulf)",
  "Join a product-based company (FAANG/MNC)",
  "Join a service-based IT company",
  "Research & Development / PhD",
];

const PERSONALITY = [
  "Analytical Thinker",
  "Creative Problem Solver",
  "People Person / Extrovert",
  "Detail-Oriented / Systematic",
  "Risk-Taker / Ambitious",
  "Collaborative Team Player",
  "Independent Worker",
  "Empathetic / Social Cause Driven",
];

export default function Step5Interests({ form, setForm }) {
  const update  = (key, val) => setForm(f => ({ ...f, [key]: val }));
  const toggle  = (key, val) => setForm(f => ({
    ...f,
    [key]: f[key].includes(val) ? f[key].filter(x => x !== val) : [...f[key], val],
  }));

  return (
    <div>
      {/* Interested Field */}
      <SelectField
        label="Primary Career Interest" required
        value={form.interestedField}
        onChange={v => update("interestedField", v)}
        options={FIELDS}
        hint="This is the #1 factor in your AI career prediction"
      />

      {/* Career Goal */}
      <SelectField
        label="Main Career Goal" required
        value={form.careerGoal}
        onChange={v => update("careerGoal", v)}
        options={GOALS}
      />

      {/* Work Type */}
      <CheckGroup
        label="Preferred Work Type (select all that apply)"
        items={WORK_TYPES}
        selected={form.workType || []}
        onToggle={v => toggle("workType", v)}
      />

      {/* Personality */}
      <CheckGroup
        label="Personality Type (pick your traits)"
        items={PERSONALITY}
        selected={form.personality || []}
        onToggle={v => toggle("personality", v)}
      />

      {/* Relocate */}
      <SelectField
        label="Willing to Relocate?"
        value={form.relocate}
        onChange={v => update("relocate", v)}
        options={[
          "Yes — Anywhere in India",
          "Yes — Only to Metro Cities",
          "Yes — Prefer to go Abroad",
          "No — Stay in My City / District",
          "No — Work from Home Only",
        ]}
      />

      {/* Target salary */}
      <SelectField
        label="Target Starting Salary (LPA)"
        value={form.targetSalary}
        onChange={v => update("targetSalary", v)}
        options={[
          "Below ₹3 LPA (Any job to start)",
          "₹3 – ₹5 LPA",
          "₹5 – ₹8 LPA",
          "₹8 – ₹12 LPA",
          "₹12 – ₹20 LPA",
          "Above ₹20 LPA (Product Company / Abroad)",
        ]}
      />

      {/* Timeline */}
      <SelectField
        label="When do you want to start working?"
        value={form.timeline}
        onChange={v => update("timeline", v)}
        options={[
          "Immediately (Open to offers)",
          "Within 3 months",
          "Within 6 months",
          "1 year (Still studying / preparing)",
          "2+ years (Long-term planning)",
        ]}
      />
    </div>
  );
}